export default "<h3>May 14, 2020</h3>\r\n<p>Version 1.81 fixes some bugs.</p>";